import { StencilCDNImage } from '@/components/Common/StencilImage'
import { GreenButton } from '@/components/NewHomepage/Button'
import Text from '@/stories/components/Common/NewText'

const EmptyWidget = () => {
  return (
    <div className="flex flex-col items-center justify-center bg-white p-4">
      <StencilCDNImage
        src="https://indcdn.indmoney.com/cdn/images/fe/empty_state_graphics.webp"
        alt="empty state"
        width={80}
        height={80}
      />
      <Text appearance="subtitle2" className="text-brand-grey-base py-4">
        Something went wrong, please try again
      </Text>
      <GreenButton btnText="Reload" navLink="" addclassName="!py-2 !px-2" />
    </div>
  )
}

export default EmptyWidget
